import { Link } from "react-router-dom"
import { ArrowLeft, Tag } from "lucide-react"

export default function OffersPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-6 md:py-8 max-w-5xl">
        <Link to="/" className="inline-flex items-center text-gray-600 hover:text-primary mb-4 md:mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Cart
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <Tag className="w-6 h-6 text-red-600" />
          <h1 className="text-3xl font-semibold">Available Coupons</h1>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-12">
          <div className="flex flex-col items-center justify-center text-center">
            <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-4">
              <Tag className="w-10 h-10 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold mb-2">No Coupons Available</h2>
            <p className="text-gray-600">There are currently no active coupons available for your account.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
